<template>
  <v-dialog v-model="isVisible" persistent :max-width="viewMode === 'clinic-fields' ? '1200px' : '600px'">
    <div v-if="isVisible" class="wrapper">
      <v-card v-if="!isLoaderActive">
        <v-card-title>
          <span class="headline">Provide Medical Group Details</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row class="fieldsRow">

              <v-col cols="6">
                <v-text-field v-model="medicalGroupFields.medicalGroupName" type="text" label="Medical Group Name *" />
                <div class="errorText">
                  {{
                    !medicalGroupFields.medicalGroupName.length && isMedicalGroupFormDirty
                      ? "Please provide a value"
                      : ""
                  }}
                </div>
              </v-col>

              <v-col cols="6">
                <v-autocomplete clearable v-model="medicalGroupFields.timeRangeBegin" :items="FilterFields.allHours"
                                label="Time Range Begin" item-text="label" item-value="value" required
                                :error="!(medicalGroupFields.timeRangeBegin && medicalGroupFields.timeRangeBegin.length) && isFormDirty" />
                <div class="errorText"></div>
              </v-col>

              <v-col cols="6">
                <v-autocomplete clearable v-model="medicalGroupFields.timeRangeEnd" :items="FilterFields.allHours"
                                label="Time Range End" item-text="label" item-value="value" required
                                :error="!(medicalGroupFields.timeRangeEnd && medicalGroupFields.timeRangeEnd.length) && isFormDirty" />
                <div class="errorText"></div>
              </v-col>

              <v-col cols="6">
                <v-select v-model="medicalGroupFields.timeZoneOffset" :items="timeZoneDropdownOptions" item-text="label"
                          item-value="value" label="Select time zone" @change="timeZoneChange($event)" />
                <div class="errorText"></div>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="actionBar">
          <v-spacer />
          <v-btn color="secondary" text @click="close">Cancel</v-btn>
          <v-btn color="primary" text @click="_submit">Submit</v-btn>
        </v-card-actions>
        <v-snackbar v-model="snackbar">
          {{ notification }}
          <template v-slot:action="{ attrs }">
            <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
          </template>
        </v-snackbar>
      </v-card>
      <v-card v-if="isLoaderActive">
        <div class="progressWrapper">
          <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
        </div>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
  import { VueMaskDirective } from "v-mask";
import Vue from "vue";
import { ApiCalls } from "../../../../api-calls";
import Api from "../../../shared-module/api";
import FilterFields from "./filter-fields";

  Vue.directive("mask", VueMaskDirective);

  export default {
    name: "AddTwilioNumber",
    props: {
      isVisible: {
        type: Boolean,
        default: false
      },
      isEditing: {
        type: Boolean,
        default: false
      },
      clinic: {
        type: Object,
        default: null
      }
    },
    data: () => ({
      snackbar: false,
      notification: '',
      eligibleClinics: [],
      FilterFields: FilterFields,
      viewMode: "clinic-list", // ['loader', 'clinic-list', 'clinic-fields', 'medical-group-fields']
      selectedClinic: null,
      selectedClinicPracticeId: -1,
      allFacilities: [],
      isLoaderActive: false,
      selectedFacilities: [],
      medicalGroupFields: {
        medicalGroupName: "",
        timeRangeBegin: "",
        timeRangeEnd: "",
        timeZoneOffset: ""
      },
      file: null,
      selectedMedicalGroup: null,
      isFormDirty: false,
      isMedicalGroupFormDirty: false,
      isFormValid: false,
      timeZoneDropdownOptions: [
        {
          label: "Pacific Standard Time",
          value: "-8"
        },
        {
          label: "Eastern Standard Time",
          value: "-5"
        },
        {
          label: "Atlantic Standard Time",
          value: "-4"
        },
        {
          label: "Central Standard Time",
          value: "-6"
        },
        {
          label: "Mountain Standard Time",
          value: "-7"
        },
        {
          label: "Alaskan Standard Time",
          value: "-9"
        },
        {
          label: "Hawaii-Aleutian Standard Time",
          value: "-10"
        },
        {
          label: "Samoa Standard Time",
          value: "-11"
        },
        {
          label: "Chamorro Standard Time",
          value: "10"
        }
      ]
    }),

    watch: {
      isVisible(val) {
        if (val) {
          this._resetForm();
          if (this.isEditing) {
            this._prepareClinicEditMode();
          } else {
            this._prepareClinicAddMode();
          }
        }
      }
    },

    created() {
    },

    methods: {

      timeZoneChange(item) {
        console.log('Selected Medical Group Time Zone Offset: ' + item);
      },
      _resetForm() {
        this.isFormDirty = false;
        this.isMedicalGroupFormDirty = false;
        this.medicalGroupFields = {
          medicalGroupName: "",
          timeRangeBegin: "",
          timeRangeEnd: "",
          timeZoneOffset: ""
        };
        this.isLoaderActive = false;
        this.selectedClinicPracticeId = -1;
        this.selectedClinic = null;
        this.file = null;
        this.viewMode = "clinic-list";
      },

      // eslint-disable-next-line no-empty-function
      async _loadEligibleClinics() { },

      close() {
        this.$emit("on-close");
      },

      _extractPracticeId(data) {
        if (data && data.length) {
          const parts = data.split("PracticeID: ");
          if (parts.length === 2) {
            // eslint-disable-next-line radix
            return parseInt(parts[1]);
          }
        }
        return null;
      },

      onFileDelete(e) {
        e.preventDefault();
        e.stopPropagation();
        this.file = null;
      },

      async _navigateToNextStep() {
        if (this.viewMode === "clinic-list") {
          this.selectedClinic = this.eligibleClinics.find(
            clinic => clinic.practice_id === this.selectedClinicPracticeId
          );
          console.log("this.selectedClinic :>> ", this.selectedClinic);
          this.viewMode = "medical-group-fields";
        }
      },

      _submit() {

        this.isFormDirty = true;
        this.isMedicalGroupFormDirty = true;

        if (!this.medicalGroupFields.medicalGroupName.length) {
          this.notification = "Please enter a valid Medical Group Name";
          this.snackbar = true;
          return;
        }
        if (!this.medicalGroupFields.timeRangeBegin.length) {
          this.notification = "Please select Time Range Begin";
          this.snackbar = true;
          return;
        }
        if (!this.medicalGroupFields.timeRangeEnd.length) {
          this.notification = "Please select Time Range End";
          this.snackbar = true;
          return;
        }
        if (!this.medicalGroupFields.timeZoneOffset === 0) {
          this.notification = "Please select a Time Zone";
          this.snackbar = true;
          return;
        }

        const payload = {
          Name: this.medicalGroupFields.medicalGroupName,
          Time_Range_Begin: parseInt(this.medicalGroupFields.timeRangeBegin),
          Time_Range_End: parseInt(this.medicalGroupFields.timeRangeEnd),
          Time_Zone_Offset: parseInt(this.medicalGroupFields.timeZoneOffset),
        };

        try {
          this.isLoaderActive = true;
          if (this.isEditing) {
            Api.medicalGroup.private.editMedicalGroup({
              payload,
              medicalGroupId: this.clinic.MedicalGroupID
            });
          } else {
            Api.medicalGroup.private.createMedicalGroup(payload);
          }
          this.$emit("on-success");
        } catch (error) {
          console.log("error :>> ", error);
          this.notification = "Unable to create medical group";
          this.snackbar = true;
        }
        this.isLoaderActive = false;
      },

      _navigateToPrevStep() {
        this.viewMode = "clinic-list";
      },

      async _preparePayload() {
        let payload = {};
        // Process file upload if needed
        let logoUrl = "";
        if (this.file) {
          logoUrl = await this._uploadLogo();
        }
        const facilities = this.selectedFacilities.map(facility => ({
          FacilityID: facility.id
        }));
        if (this.isEditing) {
          payload = {
            Company: this.selectedClinic.Company,
            Practice_ID: this.clinic.Practice_ID,
            PBPAccountNumber: this.fields.billPayAccountNumber,
            TimeZone: this.fields.timezone,
            Website: this.fields.website,
            Logo: logoUrl,
            PhoneNumber: this.fields.phoneNumber,
            Email: this.fields.email,
            Default_Payment_Msg: this.fields.defaultPaymentMessage,
            MedicalGroupID: this.selectedMedicalGroup.medicalGroupID,
            Facilities: facilities
          };
        } else {
          const selectedClinic = this.eligibleClinics.find(
            c => this.selectedClinicPracticeId === c.practice_id
          );
          payload = {
            Practice_ID: selectedClinic.practice_id,
            Company: selectedClinic.company_name,
            PBPAccountNumber: this.fields.billPayAccountNumber,
            TimeZone: this.fields.timezone,
            Website: this.fields.website,
            Logo: logoUrl,
            PhoneNumber: this.fields.phoneNumber,
            Email: this.fields.email,
            Default_Payment_Msg: this.fields.defaultPaymentMessage,
            MedicalGroupID: this.selectedMedicalGroup.medicalGroupID,
            Facilities: facilities
          };
        }

        consle.log(payload);

        return payload;
      },

      async _uploadLogo() {
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          const res = await ApiCalls.uploadMedia(formData);
          return res.data;
        } catch (error) {
          console.log("error :>> ", error);
          return "";
        }
      },

      onFileChange(e) {
        const allowedFileTypes = ["image/jpeg", "image/gif", "image/png"];
        const uploadedFile = e.target.files[0];
        // Check if file type is valid
        if (allowedFileTypes.indexOf(uploadedFile.type) > -1) {
          // Check if it exceeds the size limit
          const allowedFileSize =
            process.env.VUE_APP_MMS_ATTACHMENT_SIZE_LIMIT_IN_KB || 4 * 1024;
          if (uploadedFile.size / 1024 <= allowedFileSize) {
            this.file = e.target.files[0];
          } else {
            this.notification = `File size too large, maximum allowed size is ${allowedFileSize / 1024} MB`;
            this.snackbar = true;
          }
        } else {
          this.notification = "The selected file type is not allowed";
          this.snackbar = true;
        }
      },

      async _fetchFacilities() {
        let facilities = [];
        try {
          if (this.selectedMedicalGroup) {
            const { data } = await Api.medicalGroup.private.fetchFacilities({
              medicalGroupId: this.selectedMedicalGroup.medicalGroupID
            });
            if (data) {
              facilities = data;
            }
          }
        } catch (error) {
          console.log("error :>> ", error);
        }
        this.allFacilities = facilities;
      },

      _prepareClinicAddMode() {
        this._loadEligibleClinics();
      },

      _prepareClinicEditMode() {
        this._loadClinicData();
      },

      async _loadClinicData() {
        this.viewMode = "loader";
        // Fetch clinic data
        console.log("this.clinic :>> ", this.clinic);
        if (this.clinic) {
          this.medicalGroupFields.medicalGroupName = this.clinic.Name || "";
          this.medicalGroupFields.timeRangeBegin = String(this.clinic.Time_Range_Begin || "");
          this.medicalGroupFields.timeRangeEnd = String(this.clinic.Time_Range_End || "");
          this.medicalGroupFields.timeZoneOffset = String(this.clinic.Time_Zone_Offset || "");
          console.log('this.medicalGroupFields :>> ', this.medicalGroupFields);
        }
        this.viewMode = "clinic-fields";
      }
    }
  };
</script>

<style lang="scss" scoped>
  .a-center {
    text-align: center;
  }

  .phoneNumbersWrapper {
    max-height: 250px;
    overflow-y: scroll;
  }

  .actionBar {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 80px;
    padding-bottom: 25px;
    background-color: white;
  }

  .wrapper {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .progressWrapper {
    width: 100%;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .spinner {
      margin-left: 0rem !important;
    }

    img {
      margin-bottom: 25px;
    }
  }

  .errorText {
    margin-top: -5px;
    color: red;
    height: 15px;
  }

  .fieldsRow {
    padding-bottom: 4rem;
  }
</style>
